import {ChangeDetectionStrategy, Component} from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'myabvv-unemployment',
    standalone: true,
    templateUrl: './unemployment.component.html',
    imports: [RouterOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnemploymentComponent {
}
